import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { lookupsApi } from '../../api/endpoints/lookups';

interface LookupSelectProps {
  /** Nombre del catálogo, ej. 'activity_type'. */
  listName: string;
  value?: string | null;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  allowClear?: boolean;
  style?: React.CSSProperties;
}

/**
 * Select cerrado alimentado por un catálogo (Lookup). Guarda el `value`
 * (código) del catálogo. Para vocabularios controlados (etapas de venta,
 * tipos de actividad) — el admin edita las opciones desde /admin/catalogos.
 */
export function LookupSelect({
  listName,
  value,
  onChange,
  placeholder,
  allowClear = true,
  style,
}: LookupSelectProps): JSX.Element {
  const { data, isLoading } = useQuery({
    queryKey: ['lookups', listName],
    queryFn: () => lookupsApi.byList(listName),
    staleTime: 5 * 60_000,
  });

  return (
    <Select
      loading={isLoading}
      allowClear={allowClear}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      placeholder={placeholder}
      options={(data ?? []).map((l) => ({ value: l.value, label: l.label }))}
      style={{ width: '100%', ...style }}
    />
  );
}
